import React from 'react';
import { KAKAO_REDIRECT_URI, KAKAO_REST_API_KEY } from '../../../../constants/url';
 
import kakaoImg from '../../../../images/common/i_kakao_circle_02.svg';


const KaKaoLogin = () => {

  return (
    <button data-login-btn="kao" onClick={() => {
      console.log(KAKAO_REST_API_KEY);

      if (window.ReactNativeWebView) {
        console.log('네이티브 카카오 로그인을 요청합니다.');
        window.ReactNativeWebView.postMessage(JSON.stringify({
          type: 'REQUEST_KAKAO_LOGIN'
        }));
      } else {
        // scope : profile_nickname profile_image account_email  // 25.09.15 기준 nickname, image 필수, email 선택 옵션.
        const kakaoAuthUrl = `https://kauth.kakao.com/oauth/authorize?client_id=${KAKAO_REST_API_KEY}&redirect_uri=${KAKAO_REDIRECT_URI}&response_type=code&scope=`;
        // 스코프를 빈설정으로하면, 서버설정에 따라다님. // 관리포인트가 나뉘어져 있어, 제어에 우선권을 두고 싶다면, 셋팅하는 것도 방법임. ( 개인정보 문제로 바꿔놓고, 진위여부를 따지기가 힘드수도 있기 때문... 개발기간동안은 편의상 풀어놓기로 함.. )
        window.location.href = kakaoAuthUrl;
      }


    }}>
      <img src={kakaoImg} alt="카카오 로그인" />
      <span>카카오로 시작하기</span>
    </button>
  );
};

export default KaKaoLogin;
